import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { minWidth, units } from '@calm-web/design-system';

export const contentWrapperTabletMinHeight = '704px';

export const ContentWrapper = styled.div<{
	centerAlign?: boolean;
}>`
	background-color: ${palette('white')};
	color: ${palette('gray7')};
	display: flex;
	flex-direction: column;
	padding: ${units(5)} ${units(2.5)};
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
	border-radius: 16px;
	width: 100%;

	${ifProp(
		'centerAlign',
		css`
			text-align: center;
		`,
	)}

	${minWidth('tablet')} {
		margin: 0 auto;
		max-width: 560px;
		min-height: ${contentWrapperTabletMinHeight};
		padding: ${units(4.44)} ${units(4.67)};
	}

	${minWidth('desktop')} {
		margin-top: ${units(3.56)};
	}
`;
